import { MouseEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    colors,
    VisibilityIcon,
    VisibilityOffIcon
} from "@dotnet/telematics-design-system";

import ButtonDefault from "components/DesignComponents/ButtonDefault";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";

import { PASSWORD_TYPES } from "../types/enums";

export const useTogglePswVisibility = (pswType: string) => {
    const { gray500, gray600 } = colors;

    const { t } = useTranslation();

    const [showPassword, setShowPassword] = useState({
        current: false,
        newPsw: false,
        repeat: false
    });

    const togglePswVisibility = (
        e: MouseEvent<HTMLSpanElement>,
        name: PASSWORD_TYPES
    ) => {
        e.preventDefault();
        setShowPassword({ ...showPassword, [name]: !showPassword[name] });
    };

    const PasswordVisibility = () => {
        return (
            <TooltipGeneral
                disableTouchListener
                placement={TOOLTIP_PLACEMENT.TopEnd}
                title={
                    showPassword[pswType as PASSWORD_TYPES]
                        ? t("Security##password##hide password")
                        : t("Security##password##show password")
                }
                css={css({
                    "& .MuiTooltip-tooltip": {
                        marginRight: "-6px"
                    }
                })}
            >
                <ButtonDefault
                    onMouseDown={e =>
                        togglePswVisibility(e, pswType as PASSWORD_TYPES)
                    }
                    className="change-psw-visibility"
                    css={css({
                        display: "flex",
                        cursor: "pointer",
                        color: gray500,
                        transition:
                            "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

                        "&:hover": {
                            color: gray600
                        }
                    })}
                >
                    {showPassword[pswType as PASSWORD_TYPES] ? (
                        <VisibilityOffIcon />
                    ) : (
                        <VisibilityIcon />
                    )}
                </ButtonDefault>
            </TooltipGeneral>
        );
    };

    return { PasswordVisibility, showPassword };
};
